export const getHomeNavigationTarget = () => {
  if (typeof window === 'undefined') {
    return '/';
  }

  const hostname = window.location.hostname;

  if (
    hostname === 'app.sideo.in' ||
    hostname === 'sideo.in' ||
    hostname === 'www.sideo.in' ||
    hostname === 'sideo-pre-qr.vercel.app'
  ) {
    return 'https://www.sideo.in';
  }

  return '/';
};

export const navigateToHome = (navigate) => {
  const target = getHomeNavigationTarget();

  if (target.startsWith('http')) {
    window.location.href = target;
    return;
  }

  navigate(target);
};
